// extracted by mini-css-extract-plugin
export default {"searchClass":"src-components-Antd-Search-Search__searchClass--eYHX+"};